var render, staticRenderFns
import script from "./GenericView.vue?vue&type=script&lang=ts&"
export * from "./GenericView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96f061c",
  null
  
)

export default component.exports